import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgEye = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M27.05 13.646c-.039-.087-.965-2.142-3.025-4.201C21.281 6.7 17.815 5.25 14 5.25c-3.815 0-7.281 1.45-10.025 4.195-2.06 2.06-2.99 4.117-3.025 4.2a.875.875 0 0 0 0 .712c.039.086.965 2.14 3.025 4.2C6.719 21.3 10.185 22.75 14 22.75c3.815 0 7.281-1.45 10.025-4.193 2.06-2.06 2.986-4.114 3.024-4.2a.874.874 0 0 0 0-.711ZM14 21c-3.367 0-6.308-1.224-8.742-3.637A14.599 14.599 0 0 1 2.734 14a14.583 14.583 0 0 1 2.524-3.363C7.692 8.224 10.633 7 14 7c3.367 0 6.308 1.224 8.742 3.637A14.598 14.598 0 0 1 25.272 14c-.79 1.472-4.225 7-11.272 7Zm0-12.25a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5Zm0 8.75a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Z" />
  </svg>
);
export default SvgEye;
